// ========================================
// Widget: RRHH — Vacaciones y permisos por aprobar
// Solicitudes pendientes de todo el personal (GET /api/staff-leaves/overview), con los
// días que le quedarían a cada persona. Se aprueban o rechazan aquí mismo (la misma
// ruta que usa la ficha); nadie decide sobre sus propias solicitudes.
// ========================================

window.DashboardWidgets = window.DashboardWidgets || {};
window.DashboardWidgets.rrhh = window.DashboardWidgets.rrhh || {};

window.DashboardWidgets.rrhh.permisosAprobar = function(ctx) {
    const { leaves } = ctx;
    const W = window.DashboardWidgets.rrhh;
    const pending = leaves && leaves.pending ? leaves.pending : null;
    const initials = name => String(name || '?').split(/\s+/).slice(0, 2).map(w => w[0] || '').join('').toUpperCase();
    const range = l => l.startDate === l.endDate ? W.shortDate(l.startDate) : `${W.shortDate(l.startDate)} – ${W.shortDate(l.endDate)}`;
    const detail = l => [range(l), `${l.days} ${l.days === 1 ? 'día' : 'días'}`,
        l.kind === 'unpaid' ? 'se descuenta del sueldo' : (l.left != null ? `le quedarían ${l.left} de ${l.allowance}` : '')].filter(Boolean).join(' · ');

    let body;
    if (leaves && leaves.error) body = `<div class="rp-empty">No se pudieron cargar las solicitudes. Vuelve a entrar en el panel.</div>`;
    else if (!pending) body = `<div class="rp-empty"><i class="fas fa-spinner fa-spin"></i> Cargando solicitudes…</div>`;
    else if (!pending.length) body = `<div class="rp-empty">No hay solicitudes pendientes.</div>`;
    else body = pending.map(l => `
        <div class="rp-row">
            <span class="rp-avatar" aria-hidden="true">${Utils.sanitizeHTML(initials(l.name))}</span>
            <span class="rp-row-text">
                <button type="button" class="rp-card-link rp-row-name" style="text-decoration: none; text-align: left;" ${UIEvents.attr("click", function(event,captured){App.navigate('profesor/' + String(captured[0]));}, [l.professorId])}>${Utils.sanitizeHTML(l.name || 'Persona')}</button>
                <span class="rp-row-detail">${Utils.sanitizeHTML(detail(l))}${l.note ? ` · «${Utils.sanitizeHTML(l.note)}»` : ''}</span>
            </span>
            <span class="rp-badge ${l.kind === 'unpaid' ? 'is-warn' : 'is-ok'}">${l.kind === 'unpaid' ? 'Sin sueldo' : 'Vacaciones'}</span>
            ${l.own ? '<span class="rp-muted">La decide otra persona</span>' : `<span class="rp-actions">
                <button type="button" class="rp-btn is-danger" ${UIEvents.attr("click", function(event,captured){window.DashboardWidgets.rrhh.decideLeave(String(captured[0]), false, this);}, [l.id])}>Rechazar</button>
                <button type="button" class="rp-btn is-primary" ${UIEvents.attr("click", function(event,captured){window.DashboardWidgets.rrhh.decideLeave(String(captured[0]), true, this);}, [l.id])}>Aprobar</button>
            </span>`}
        </div>`).join('');

    const inner = `
        <div class="rp-card-head">
            <h2 class="rp-card-title">Vacaciones y permisos por aprobar</h2>
            ${pending && pending.length ? `<span class="rp-badge is-warn">${pending.length} ${pending.length === 1 ? 'pendiente' : 'pendientes'}</span>` : ''}
        </div>
        <div>${body}</div>`;
    return W.card(ctx, inner);
};

/** Approves or rejects (asking for a reason) one request, then refreshes the panel's leave data. */
window.DashboardWidgets.rrhh.decideLeave = function(leaveId, approve, button) {
    const send = async note => {
        if (button) button.disabled = true;
        try {
            const response = await fetch(`/api/staff-leaves/${encodeURIComponent(leaveId)}/decision`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(approve ? { approve: true } : { approve: false, note })
            });
            const body = await response.json();
            if (!response.ok || !body.success) throw new Error(body.error || 'No se pudo completar.');
            Utils.showToast(approve ? 'Ausencia aprobada.' : 'Ausencia rechazada.', 'success');
            CategoryDashboards.refreshRrhhLeaves();
        } catch (e) {
            Utils.showToast(e.message, 'error');
            if (button) button.disabled = false;
        }
    };
    if (approve) return send();
    ModalManager.show('Rechazar ausencia', `
        <div class="dnr-proposal professor-form-dnr">
        <form id="rp-reject-form" class="form-container">
            <div class="form-group">
                <label class="form-label" for="rp-reject-reason">Motivo (se le enviará en el aviso)</label>
                <input type="text" class="form-input" id="rp-reject-reason" name="reason" maxlength="500">
            </div>
            <div class="form-actions">
                <button type="button" class="btn btn-secondary" ${UIEvents.attr("click", function(event,captured){ModalManager.closeModal();}, [])}>Cancelar</button>
                <button type="submit" class="btn btn-danger">Rechazar</button>
            </div>
        </form>
        </div>`);
    document.getElementById('rp-reject-form').addEventListener('submit', event => {
        event.preventDefault();
        const reason = event.target.reason.value;
        ModalManager.closeModal();
        send(reason);
    });
};
